module.exports = __webpack_public_path__ + "media/images/logo-header-77a10b568a931f93b7927f12be183f37.png";